<template>
    <div class="c-product-size-scope">
        <div class="c-product-size" :class="{'is-valid' : isValid, 'is-invalid': isInvalid, 'is-disabled': isDisabled || localLoading}">
            <v-input :disabled="isDisabled" :horizontal="false" type="number" :min="0" :name="`${_uid}-product-size`" input-size="small" :value="item.Amount" v-model.number="localItem.Amount" @change="updateItem">
                <span slot="label" class="u-text-align-center u-block u-margin-bottom-tiny">{{item.Size}}</span>
            </v-input>
        </div>
        <div class="c-product-size__stock u-flex--content-center c-icon-label c-icon-label--small u-font-tiny u-margin-top-tiny" :class="{'is-valid' : isValid, 'is-invalid': isInvalid}" v-if="typeof localItem.Stock !== 'undefined'">
            <template v-if="localItem.Stock && localItem.Stock > 0">
                <svgicon name="check" width=".8em" height=".8em" class="u-svg-color-success-base"></svgicon>
                <span>Stock: {{ localItem.Stock }}</span>
            </template>
            <template v-else>
                <svgicon name="cross" width=".6em" height=".6em" class="u-svg-color-alpha-base"></svgicon>
                <span>Niet in stock</span>
            </template>
        </div>
        <div class="c-product-size__stock u-flex--content-center c-icon-label c-icon-label--small u-font-tiny u-margin-top-tiny" v-if="showStockForPreOrder">
            <span>Stock: {{ localItem.AmountInStock }}</span>
        </div>
        <div class="c-product-size__stock u-flex--content-center c-icon-label c-icon-label--small u-font-tiny u-margin-top-tiny" v-if="showStockForPreOrder">
            <span>Future stock: {{ localItem.FutureAvailableStock - localItem.AmountInStock }}</span>
        </div>
    </div>
</template>

<script>
    import debounce from 'lodash/debounce'
    import VInput from '@/components/form/Input'

    export default {
        props: {
            item: Object,
            disabled: { type: Boolean, default: false },
            showStockForPreOrder: { type: Boolean, default: false }
        },
        data() {
            return {
                localItem: this.item,
                localLoading: false,
                updateProductVariant: debounce(function () {
                  this.$emit('loaded', {});
                  this.localLoading = true;

                  this.$store.dispatch('updatePreOrderProductVariant', {
                    preOrderId: this.$route.params.id,
                    productVariantId: this.localItem.Id,
                    body: {
                      Id: this.localItem.Id,
                      Amount: this.localItem.Amount
                    }
                  }).then(() => {
                    this.$emit('loaded', { isLoaded: true });
                    this.localLoading = false;

                    this.$store.dispatch('getPreOrderTotalsById', this.$route.params.id);
                  });
                }, 500)
            }
        },
        computed: {
            isValid() {
                if (typeof this.localItem.Stock !== 'undefined' && this.localItem.Amount > 0) {
                    return this.localItem.Amount <= this.localItem.Stock;
                }
            },
            isInvalid(){
                if (typeof this.localItem.Stock !== 'undefined') {
                    return this.localItem.Amount > this.localItem.Stock;
                }
            },
            isDisabled(){
                if(this.disabled) return this.disabled;

                if (typeof this.localItem.Stock !== 'undefined') {
                    return !this.localItem.Stock > 0;
                } else {
                    return !(this.localItem.IsEnabled && this.localItem.IsAvailable);
                }
            }
        },
        watch: {
          'localItem.Amount'() {
            if (typeof this.localItem.Amount === 'string') {
              this.localItem.Amount = 0;
            }
          }
        },
        methods: {
            updateItem() {
                this.updateProductVariant();
                this.$emit('update:item', this.localItem);
            }
        },
        components: {
            VInput,
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";
    @import "~@/assets/scss/private";

    .c-product-size {
        border: 1px dashed palette(color-neutral, light);
        padding: em($global-spacing-unit-small);

        &.is-valid{
            border-color: $color-success;
            border-style: solid;
            background-color: rgba($color-success, .05);
        }

        &.is-invalid{
            border-color: $color-error;
            border-style: solid;
            background-color: rgba($color-error, .05);
        }

        &.is-disabled{
            opacity:.5;
        }
    }

    .c-product-size__stock{
        border: 1px solid transparent;
        &.is-invalid{
            border: 1px solid $color-error;
        }
    }
</style>

<style lang="scss">

    @import "~@/assets/scss/private";

    .c-product-size {
        max-width: 120px;
        min-width: 80px;

        label {
            margin-bottom: em($global-spacing-unit-tiny);
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/product/widgets/productSizeInput.vue